import { getPath } from '@/router/common'
// 开票管理登录页面和其他登录页面放一起了，方便后期白名单统一管理
const baseUrl = {
  title: '开票管理',
  path: 'Settlement'
}
// /Settlement/BindingDriver
// /Settlement/DriverAuth
// /Settlement/AddDriverAuth
// /Settlement/AddDriverAuthNew
// /Settlement/AddVehicleAuth
// /Settlement/VehicleAuth
// /Settlement/addgc
// Settlement/selectgcList
// /Settlement/YOrderLists
// /Settlement/DYOrder
// /Settlement/SOrderLists
// /Settlement/AddressSetting
// /Settlement/Openticket
// /Settlement/Invoiced
export default [
  {
    path: getPath('BindingDriver', baseUrl),
    name: 'BindingDriver',
    component: () => import(/* webpackChunkName: "BindingDriver" */ '@/views/settlement/bindingDriver/index.vue'),
    meta: {
      title: '绑定司机'
    }
  },
  {
    path: getPath('DriverAuth', baseUrl),
    name: 'DriverAuth',
    component: () => import(/* webpackChunkName: "DriverAuth" */ '@/views/settlement/driverAuth/index.vue'),
    meta: {
      title: '司机列表'
    }
  },
  {
    path: getPath('AddDriverAuth', baseUrl),
    name: 'AddDriverAuth',
    component: () => import(/* webpackChunkName: "AddDriverAuth" */ '@/views/settlement/addDriverAuth/index.vue'),
    meta: {
      title: '签订合同'
    }
  },
  {
    path: getPath('AddDriverAuthNew', baseUrl),
    name: 'AddDriverAuthNew',
    component: () => import(/* webpackChunkName: "AddDriverAuthNew" */ '@/views/settlement/addDriverAuthNew/index.vue'),
    meta: {
      title: '添加编辑司机'
    }
  },
  {
    path: getPath('AddVehicleAuth', baseUrl),
    name: 'AddVehicleAuth',
    component: () => import(/* webpackChunkName: "AddVehicleAuth" */ '@/views/settlement/addVehicleAuth/index.vue'),
    meta: {
      title: '添加编辑车辆'
    }
  },
  {
    path: getPath('VehicleAuth', baseUrl),
    name: 'VehicleAuth',
    component: () => import(/* webpackChunkName: "VehicleAuth" */ '@/views/settlement/vehicleAuth/index.vue'),
    meta: {
      title: '车辆列表'
    }
  },
  {
    path: getPath('addgc', baseUrl),
    name: 'AddGC',
    component: () => import(/* webpackChunkName: "Addgc" */ '@/views/settlement/addgc/index.vue'),
    meta: {
      title: '添加编辑挂车'
    }
  },
  {
    path: getPath('selectgcList', baseUrl),
    name: 'SelectgcList',
    component: () => import(/* webpackChunkName: "selectgcList" */ '@/views/settlement/selectgcList/index.vue'),
    meta: {
      title: '挂车列表'
    }
  },
  {
    path: getPath('YOrderLists', baseUrl),
    name: 'YOrderLists',
    component: () => import(/* webpackChunkName: "YOrderLists" */ '@/views/settlement/yorderLists/index.vue'),
    meta: {
      title: '已下单记录'
    }
  },
  {
    path: getPath('DYOrder', baseUrl),
    name: 'DyOrder',
    component: () => import(/* webpackChunkName: "DYOrder" */ '@/views/settlement/dyOrder/index.vue'),
    meta: {
      title: '调整运价'
    }
  },
  {
    path: getPath('SOrderLists', baseUrl),
    name: 'SOrderLists',
    component: () => import(/* webpackChunkName: "SOrderLists" */ '@/views/settlement/sorderLists/index.vue'),
    meta: {
      title: '下单失败记录'
    }
  },
  {
    path: getPath('AddressSetting', baseUrl),
    name: 'AddressSetting',
    component: () => import(/* webpackChunkName: "AddressSetting" */ '@/views/settlement/addressSetting/index.vue'),
    meta: {
      title: '收货地址管理'
    }
  },
  {
    path: getPath('Openticket', baseUrl),
    name: 'OpenTicket',
    component: () => import(/* webpackChunkName: "Openticket" */ '@/views/settlement/openticket/index.vue'),
    meta: {
      title: '待开票记录'
    }
  },
  {
    path: getPath('Invoiced', baseUrl),
    name: 'InVoiced',
    component: () => import(/* webpackChunkName: "Invoiced" */ '@/views/settlement/invoiced/index.vue'),
    meta: {
      title: '已开票记录'
    }
  },
  {
    path: getPath('PayeeAuth', baseUrl),
    name: 'PayeeAuth',
    component: () => import(/* webpackChunkName: "PayeeAuth" */ '@/views/settlement/payeeAuth/index.vue'),
    meta: {
      title: '司机档案'
    }
  },
  {
    path: getPath('AddPayeeAuth', baseUrl),
    name: 'AddPayeeAuth',
    component: () => import(/* webpackChunkName: "AddPayeeAuth" */ '@/views/settlement/addPayeeAuth/index.vue'),
    meta: {
      title: '添加编辑车辆'
    }
  },
  {
    path: getPath('SettlementXY', baseUrl),
    name: 'SettlementXY',
    component: () => import(/* webpackChunkName: "SettlementXY" */ '@/views/settlement/settlementXY/index.vue'),
    meta: {
      title: '用户规则'
    }
  },
  {
    path: getPath('HomeIndex', baseUrl),
    name: 'Settlement_HomeIndex',
    component: () => import(/* webpackChunkName: "Settlement_HomeIndex" */ '@/views/settlement/homeIndex/index.vue'),
    meta: {
      title: '首页'
    }
  }

]
